module.exports = __webpack_public_path__ + "img/image-36.ad2d4b52.jpg";